import { FilterXIcon, InboxIcon, XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateHeading,
  EmptyStateIcon,
} from "@/components/ui/empty-state";
import { useView } from "@/features/view/components/ViewProvider";
import { accessionListHasNarrowingFilters } from "../lib/accession-list-filters";

export function AccessionListEmptyState() {
  const { resetFilters, dirtyFilters, filters } = useView();
  const narrowed = accessionListHasNarrowingFilters(filters);

  if (!narrowed) {
    return (
      <EmptyState className="min-h-[min(380px,60vh)] max-w-md py-12 md:py-16">
        <EmptyStateIcon>
          <InboxIcon className="size-12 stroke-[1.25]" aria-hidden />
        </EmptyStateIcon>
        <EmptyStateHeading>No accessions to display</EmptyStateHeading>
        <EmptyStateDescription>
          There are no accessions in this list right now. New accessions will
          show up here when they are created for labs you can access.
        </EmptyStateDescription>
      </EmptyState>
    );
  }

  return (
    <EmptyState className="min-h-[min(380px,60vh)] max-w-lg py-12 md:py-16">
      <EmptyStateIcon>
        <FilterXIcon className="size-12 stroke-[1.25]" aria-hidden />
      </EmptyStateIcon>
      <EmptyStateHeading>No accessions match your filters</EmptyStateHeading>
      <EmptyStateDescription>
        Try widening your criteria or clearing extra filters you applied on top
        of this view. Saved views keep their baseline filters until you edit the
        view.
      </EmptyStateDescription>
      {dirtyFilters ? (
        <EmptyStateActions>
          <Button variant="outline" onPress={() => resetFilters()}>
            <XIcon aria-hidden />
            Clear filters
          </Button>
        </EmptyStateActions>
      ) : null}
    </EmptyState>
  );
}
